<template>
  <standard-container
    :title="$t('schedule.player-title')"
    overflow="auto"
  >
    <template v-slot:title>
      <transition name="players-autocomplete-slide">
        <v-text-field
          v-if="showSearch"
          id="players-autocomplete"
          v-model="search"
          class="players-autocomplete"
          :label="$t('schedule.player-search')"
          :items="getAllItemsName"
          single-line
          hide-details
          clearable
        />
      </transition>
      <v-btn
        icon
        @click="showSearch = !showSearch"
      >
        <v-icon> search </v-icon>
      </v-btn>
    </template>
    <template v-slot:content>
      <v-flex>
        <v-treeview
          v-model="cSelectedPlayer"
          :items="playersItem"
          :selectable="true"
          open-on-click
          :hoverable="true"
          :search="search"
          return-object
          dense
        >
          <template v-slot:append="{ item }">
            <template v-if="item !== undefined">
              <v-icon v-if="item.color">mdi-calendar-clock</v-icon>
            </template>
          </template>
        </v-treeview>
      </v-flex>
    </template>
  </standard-container>
</template>

<script>
// Components
import standardContainer from "../../Common/StandardContainer";

export default {
  components: {
    standardContainer,
  },
  props: {
    playersItem: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showSearch: false,
      search: "",
      selectedPlayer: [],
    };
  },
  computed: {
    getAllItemsName() {
      return this.getOnlyTheItemsName(this.playersItem[0]).sort();
    },
    cSelectedPlayer: {
      get() {
        return this.selectedPlayer;
      },
      set(val) {
        this.selectedPlayer.forEach((players) => {
          players.color = 0;
        });

        this.selectedPlayer = val;
        this.$emit("playerSelected", this.selectedPlayer);
      },
    },
  },
  methods: {
    getOnlyTheItemsName(treePlayers) {
      let itemsName = [];
      itemsName.push(this.getTheItemName(treePlayers, itemsName));
      return itemsName;
    },
    getTheItemName(item, itemsName) {
      if (!item.hasOwnProperty("children")) {
        return item.name;
      } else {
        item.children.forEach((child) => {
          itemsName.push(this.getTheItemName(child, itemsName));
        });
      }
      return item.name;
    },
  },
};
</script>

<style>
.players-autocomplete {
  top: 20%;
}

.players-autocomplete-slide-enter-active,
.players-autocomplete-slide-leave-active {
  transition: opacity 0.5s;
}

.players-autocomplete-slide-enter,
.players-autocomplete-slide-leave-to {
  opacity: 0;
}
</style>
